import React from "react";
import { Send, Shield, GraduationCap, Flame } from "lucide-react";
import { Reveal, SectionHeading, TiltCard } from "./Atoms";

const MINI = [
  { icon: GraduationCap, t: "Prophetic Training", b: "Grow in discernment, spiritual maturity, and biblical prophetic understanding." },
  { icon: Flame, t: "Apostolic Equipping", b: "Be strengthened for assignment, service, leadership, and Kingdom purpose." },
  { icon: Shield, t: "Spiritual Covering", b: "A ministry environment rooted in prayer, holiness, accountability, and the Word of God." },
  { icon: Send, t: "Revival Alignment", b: "Walk with others hungry for consecration, deliverance, and the fire of the Holy Ghost." },
];

const Mentorship = () => {
  return (
    <section id="mentorship" className="relative py-28 px-6 bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            overline="Prophetic Mentorship & Spiritual Covering"
            title={<>Be <span className="italic gold-text">trained</span>. Be sharpened. Carry the fire.</>}
            subtitle="If you are seeking spiritual covering, prophetic training, apostolic equipping, and a ministry environment that carries a strong grace for prayer, holiness, deliverance, discernment, and the fire of God — we invite you into our Prophetic Mentorship Group."
          />
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7">
            <Reveal delay={60}>
              <p className="text-[#D9D9D9] text-[15px] leading-relaxed">
                This group is for those who desire to be trained, sharpened, strengthened,
                and equipped under the mandate of Revival Fire Ministries Global. Whether
                you are growing in your calling, seeking alignment, desiring deeper prophetic
                understanding, or looking for a place of covering, accountability, prayer,
                and equipping — this is a pathway to stay connected, receive impartation,
                and walk with others who are hungry for revival, holiness, and the fire
                of the Holy Ghost.
              </p>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-4 font-serif-display italic text-2xl text-[#F6F0E6]">
                Come ready to be trained. Come ready to be sharpened. Come ready to carry the fire.
              </p>
            </Reveal>
            <Reveal delay={220}>
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <a
                  href="https://t.me/+5JNzlS_s3ac0NmUx"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-fire"
                  data-testid="mentorship-telegram"
                >
                  <Send className="h-4 w-4" strokeWidth={1.7} />
                  Join the Prophetic Mentorship Group
                </a>
                <a href="#contact" className="btn-ghost" data-testid="mentorship-contact">
                  Ask a Question
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {MINI.map(({ icon: Icon, t, b }, i) => (
              <Reveal key={t} delay={i * 80}>
                <TiltCard strength={3}>
                  <div className="bento-card h-full !p-6 min-h-[170px]" data-testid={`mentorship-card-${i}`}>
                    <span className="glow-blob" />
                    <Icon className="h-5 w-5 text-[#C9A44C]" strokeWidth={1.5} />
                    <h4 className="mt-4 font-serif-display text-xl text-[#F6F0E6] leading-tight">{t}</h4>
                    <p className="mt-2 text-[13.5px] text-[#D9D9D9] leading-relaxed">{b}</p>
                  </div>
                </TiltCard>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mentorship;
